
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chessparty",
      function () {
        return require("private-next-pages/chessparty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chessparty"])
      });
    }
  